<template>
  <v-dialog v-model="visible" width="500">
    <v-card>
      <v-img src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/license-sample.png"></v-img>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>

<style>
</style>
